import { csx } from '@vtex/admin-ui'

const styles = {
  tagsList: csx({ gap: '$space-2' }),
  editor: {
    content: csx({
      gap: '$space-6',
      '.label': { paddingBottom: '$space-2', display: 'block' },
      '> *': { width: 'full' },
    }),
    list: csx({ gap: '$space-4' }),
    range: csx({
      gap: '$space-2',
      alignItems: 'baseline',
      '> div': { width: 'full' },
    }),
    addRangeButton: csx({ marginTop: '$space-4' }),
    removeButton: csx({ alignSelf: 'flex-start' }),
  },
}

export default styles
